import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { RetiredContent } from "JS/Models/RetiredContent";

export class RetiredContentService extends BaseService {
    getRetiredContent(contentTypes: string) {
        return this.ngCall<RetiredContent>(
            "get",
            appConstants.ngEndpoints.getRetiredContent(
                config.user.memberId,
                contentTypes,
            ),
        );
    }
}
